import { render } from "./TransferTemplateEditor.vue?vue&type=template&id=2fe9a67c&scoped=true"
import script from "./TransferTemplateEditor.vue?vue&type=script&lang=js"
export * from "./TransferTemplateEditor.vue?vue&type=script&lang=js"

import "./TransferTemplateEditor.vue?vue&type=style&index=0&id=2fe9a67c&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe9a67c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QBtn});
